<template>
    <div class="scancode">
        <div class="scan_code_top" :style="scan_top_bg">
            <div class="shidailian" :style="shidailian"></div>
        </div>
        <div class="de">
            <ul class="scan_code_desc">
                <li>一物一码</li>
                <li>扫码溯源</li>
            </ul>
            <div class="do_scan" @click="toScan()">
                <img :src="publicPath + 'statics/images/blockchain/scan-ico.png'" alt="" />
                开始扫码
            </div>
            <!-- <div class="go_shop" @click="goShop()">进入商城</div> -->
        </div>
        
    </div>
</template>

<script>
import router from '../../../.././router';
import { LOGOUT, LOGIN } from '../../../.././vuex/mutation_types';
import PageSearch from '../../../component/search/Index.vue';
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js';
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: 'my-index',
    data() {
        return {
            publicPath: process.env.BASE_URL,
            scan_top_bg: { background: "url('" + process.env.BASE_URL + "statics/images/blockchain/scan_top.png') top center no-repeat" },
            shidailian: { background: "url('" + process.env.BASE_URL + "statics/images/blockchain/shidailian.png') top center no-repeat" },
            token: null,
        };
    },
    created: function() {
        //根据userAgent判断是否在iOSAndroid客户端中
        var that = this
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true;
            var params = {
                data: {
                    naviBlackStyle: true,
                    naviTitle: "追溯码查询",
                    levitate: true,
                    'rightStyle': 'share'
                }
            };
            this.$bridge.callhandler('sdjy://navigation/style', params, data => {});
            var memberParams = {
                data: {
                    notCallLogin: 1
                }
            };
            //加载用户信息
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, data => {
                console.log(data);
                if (data.code == 200) {
                    this.token = data.result.token;
                }
            });
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success');
            });
            //注册方法，右侧点击分享
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                console.log('sdjy://common/rightButtonAction')
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: '时代链',
                        detail: '让你的商品来源可溯，去向可追！',
                        url: url,
                        platFormType:'',
                        image: that.$publicData.shareImgPath + 'shidailian.jpg'
                    },
                };
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })

            })
        } else {
            this.isClient = false;
            this.token = this.$store.getters.token;
            this.getShareData()
        }
    },
    mounted: function() {},
    methods: {
        // 调扫码
        toScan() {
            console.log('1')
            var that = this
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                //加载用户信息
                this.$bridge.callhandler('sdjy://public/scanQRCode', {}, data => {
                    console.log(data);
                    if (data.code == 200) {
                        var params = {
                            data: {
                                url: data.result.qrcode
                            }
                        };
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, data => {});
                    }
                });
            } else {
                wx.scanQRCode({
                    needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                    scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
                    success: function(res) {
                        console.log(res);
                        var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                        
                        window.open(result)
                        console.log(result);
                    },
                    fail: function(err) {
                        console.log('调扫码失败，'+ err)
                    }
                });
            }
            
            console.log('2')
        },
        // 获取商品信息
        goShop() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var name = 'chain/index';
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + '/' + name
                    }
                };
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, data => {});
            } else {
                this.$router.push({
                    name: 'chain-index'
                });
            }
        },
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: '时代链', // 分享标题
                    desc: '让你的商品来源可溯，去向可追！', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.$publicData.shareImgPath + 'shidailian.jpg', // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.scan_code_top {
    position: absolute;
    top:0;
    bottom:4.333rem;
    width: 10rem;
    /* height: 11.59rem; */
    background-size: 100% auto !important;
    background-position: bottom center !important;
}

.scan_code_top .shidailian {
    position: absolute;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    width:1.6rem;
    height:5.52rem;
    background-size: 100% auto !important;
    /* background-position: bottom center !important; */
}

.de {
    position: absolute;
    bottom:0;
    left:0;
    width:10rem;
    height:4.333rem;
}

.scan_code_desc {
    height: 0.35rem;
    line-height: 0.35rem;
    margin: 0.4rem auto 0.5rem auto;
    font-size: 0.35rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.7);
    text-align: center;
    /* display: flex; */
}

.scan_code_desc li {
    position: relative;
    height: 0.35rem;
    line-height: 0.35rem;
    padding: 0 0.8rem;
    display: inline-block;
}

.scan_code_desc li::after {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    content: '';
    width: 0.01rem;
    height: 0.24rem;
    border-right: 0.01rem solid rgba(12, 2, 5, 0.5);
    display: block;
}

.scan_code_desc li:last-child::after {
    display: none;
}

.do_scan {
    width: 7.73rem;
    height: 1.33rem;
    line-height: 1.33rem;
    margin: 0 auto;
    background: linear-gradient(-90deg, #008eff, #4da9ff);
    border-radius: 1rem;
    text-align: center;
    font-size: 0.43rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ffffff;
}

.do_scan img {
    width: 0.49rem;
    height: 0.45rem;
    margin-right: 0.27rem;
    vertical-align: middle;
}

.go_shop {
    width: 5em;
    height: 0.37rem;
    line-height: 0.37rem;
    margin: 0.36rem auto;
    font-size: 0.37rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #000;
    text-align: center;
}
</style>
